'use client';

import { createContext, useContext } from 'react';
import { Brand } from '../index.js';

export const brandContext = createContext<{
  brand: Brand;
  setBrand?: (brand: Brand) => void;
} | null>(null);

export const BrandProvider = ({
  brand,
  children,
}: {
  brand: Brand;
  children: React.ReactNode;
}) => (
  <brandContext.Provider value={{ brand }}>{children}</brandContext.Provider>
);

export const useBrand = () => {
  const brand = useContext(brandContext)?.brand;
  if (!brand) {
    throw new Error('Attempted to access Brand before it was set.');
  }
  return brand;
};
